export default __webpack_public_path__ + "static/media/flips_logo_mobile_2019.8b310ab8.png";